import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { ErrorMessageResponse } from '@app/core/models/data-response';

@Injectable({
    providedIn: 'root',
})
export class CarrierService {
    constructor(private datatask: DataTaskService) {}

    public getCarriers(): Promise<CarrierItem[]> {
        return this.datatask.Post(2664, {});
    }

    public async getCarrier(carrierKeyno: string): Promise<CarrierGet> {
        return (await this.datatask.Post(2665, { carrier_keyno: carrierKeyno }))[0];
    }

    public async saveCarrier(page: CarrierGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(2666, page))[0];
    }

    public async printLabels(params: PrintCarrierLabelsParams): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(2933, params))[0];
    }

    public getCarriersKeyNames(params?: GetCarriersKeyNamesParams): Promise<CarrierKeyNameItem[]> {
        return this.datatask.Post(4023, params);
    }
}

export interface CarrierItem {
    carrier_keyno: string | number;
    carrier_name: string;
}

export interface CarrierGet extends CarrierItem {
    weight: string | number;
    length_cm: string | number;
    width_cm: string | number;
    height_cm: string | number;
    prod_id: string;
    prod_name: string;
    url_picture: string;
}

export interface PrintCarrierLabelsParams {
    carrier_keyno: string | number;
    report_keyno: string | number;
    printer_keyno: string | number;
    quantity: string | number;
}

export interface CarrierKeyNameItem {
    carrier_keyno: string;
    carrier_name: string;
    carrier_keyname: string;
}

export interface GetCarriersKeyNamesParams {
    language_id?: string;
}
